<template>
  <div>
    <CentrisModal v-if="modalOpened" @close="closeModal" />

    <AboutProject
      :line="line"
      :titleFirst="''"
      :titleSecond="''"
      :titleImg="
        require('@/assets/images/projectsPage/shtarsystem/titleLogo.svg')
      "
      :styleTitleFirst="styleTitleFirst"
      :styleTitleSecond="styleTitleSecond"
      :pFirst="pFirst"
      :pSecond="pSecond"
    ></AboutProject>
    <MainVideo
      :posterVideo="require('@/assets/video/webDevelopment/shtarsystem.mp4')"
    ></MainVideo>
    <Content
      :posterVideo="
        require('@/assets/images/projectsPage/shtarsystem/posterVideo.png')
      "
      :firstPhone="
        require('@/assets/images/projectsPage/shtarsystem/firstPhone.png')
      "
      :secondPhone="
        require('@/assets/images/projectsPage/shtarsystem/secondPhone.png')
      "
      :laptopVideo="require('@/assets/video/webDevelopment/shtarsystem.mp4')"
      :phoneVideo="require('@/assets/video/webDevelopment/shtarsystem-mob.mp4')"
    ></Content>
    <ShtarAnimation></ShtarAnimation>
    <Tablet
      :upImg="require('@/assets/images/projectsPage/shtarsystem/up.png')"
      :middleImg="
        require('@/assets/images/projectsPage/shtarsystem/middle.png')
      "
    ></Tablet>

    <Gallery></Gallery>
    <CentrisFooter class="smm__footer" />
    <CentrisFooterSocial class="smm__footer-social" />
  </div>
</template>

<script>
import CentrisModal from "@/components/modals/CentrisModal.vue";
import CentrisFooter from "../components/CentrisFooter.vue";
import CentrisFooterSocial from "../components/CentrisFooterSocial.vue";
import Gallery from "@/components/webDevelopment/Gallery.vue";

import MainVideo from "@/components/projectsPage/mainVideo.vue";
import AboutProject from "@/components/projectsPage/aboutProject.vue";
import Content from "@/components/projectsPage/content.vue";
import Tablet from "@/components/projectsPage/tablet.vue";
import ShtarAnimation from "@/components/projectsPage/shtarsystem/shtarAnimation.vue";

export default {
  data() {
    return {
      line: {
        first: "UX / UI Design",
        second: "Каталог из 500 позиций",
        third: "Анимация",
        fourth: "Адаптивность",
        fifth: "Кросс-браузерность",
      },
      pFirst:
        "«SHTAR SYSTEM» — профи в области системной интеграции и безопасности. Все виды систем безопасности и охраны, чтобы защитить ваши ценности и сделать вашу жизнь комфортной и безопасной.",
      pSecond:
        "Имеют полный спектр качественных услуг, начиная с разработки и внедрения информационной инфраструктуры и заканчивая сопровождением и обслуживанием.",
      styleTitleFirst: {
        fontFamily: "Orbitron",
      },
      styleTitleSecond: {},
    };
  },
  mounted() {},
  components: {
    CentrisModal,
    CentrisFooter,
    CentrisFooterSocial,
    Gallery,
    MainVideo,
    AboutProject,
    Tablet,
    Content,
    ShtarAnimation,
  },

};
</script>

<style></style>
